<template>
    <div>
        <div class="row">
            <div class="col-md-6">
                <iframe class="iframe-size"
                        src="https://www.youtube.com/embed/kSgIY_z1zdo">
                </iframe>
            </div>
            <div class="col-md-6 pt-4 pt-md-0">
                <h4>Dolor Vestibulum</h4>
                <p>
                    Donec id elit non mi porta gravida at eget metus.
                    Donec ullamcorper nulla non metus auctor fringilla.
                    Praesent commodo cursus magna, vel scelerisque nisl consectetur et.
                </p>
                <p>
                    Praesent commodo cursus magna, vel scelerisque nisl consectetur et.
                    Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
                    Curabitur blandit tempus porttitor.
                    Integer posuere erat a ante venenatis dapibus posuere velit aliquet.
                </p>
            </div>
        </div>
        <div>
            <div class="text-center mb-5 pt-5"><img src="/TLM_logo.gif"/></div>
            <div class="text-center">scelerisque | porta | vestibulum | dapibus</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CustomerDashOutro"
    }
</script>

<style scoped>

</style>